import {
  FETCH_WEATHER_STATIONS_FAILURE,
  FETCH_WEATHER_STATIONS_REQUEST,
  FETCH_WEATHER_STATIONS_SUCCESS,
} from "../actions/weatherStations.action";

const initialState = {
  data: null,
  loading: false,
};

const weatherStations = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WEATHER_STATIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_WEATHER_STATIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case FETCH_WEATHER_STATIONS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default weatherStations;
